import { render } from "./TransitionPage.vue?vue&type=template&id=244587e8&scoped=true"
import script from "./TransitionPage.vue?vue&type=script&lang=js"
export * from "./TransitionPage.vue?vue&type=script&lang=js"

import "./TransitionPage.vue?vue&type=style&index=0&id=244587e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/new-website/new-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244587e8"]])

export default __exports__